var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sgcq-topbar'),_c('sgcq-sidebar'),_c('sgcq-tabspanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }